import "@/App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { SiteFooter } from "./components/SiteFooter";
import { SiteHeader } from "./components/SiteHeader";
import { ScrollToTop } from "./components/ScrollToTop";
import Home from "./pages/Home";
import Activities from "./pages/Activities";
import Accommodation from "./pages/Accommodation";
import About from "./pages/About";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div data-testid="app-shell" className="min-h-screen bg-[#0A0F1C]">
        <SiteHeader />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/activities" element={<Activities />} />
          <Route path="/accommodation" element={<Accommodation />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <SiteFooter />
        <Toaster richColors position="top-right" />
      </div>
    </BrowserRouter>
  );
}

export default App;
